import axios from 'axios'
const http = axios.create({
  baseURL: 'https://mct.drcnet.com.cn/reportapi/NewCultureIndustryController/cultureindustry',
  // 请求 30s 超时
  // timeout: 300000
})
export default http